// @flow
import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import AuthCard from '../../../../components/AuthCard'
import Input from '../../../../components/Input'
import Button from '../../../../components/Button'

type Props = {
  onSubmit: Function,
  handleSubmit: Function,
  submitting: boolean
}

class ResetPasswordForm extends Component {
  props: Props

  handleSubmit = (data) => this.props.onSubmit(data)

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <AuthCard>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <h5 style={{ color: 'rgb(120,130,140)', marginBottom: '1.5rem' }}>
            Reset password
          </h5>
          <Field
            name="password"
            type="password"
            component={Input}
            placeholder="Password"
            style={{ marginBottom: '1rem' }}
          />
          <Button color="primary" disabled={submitting} animating={submitting}>
            Submit
          </Button>
        </form>
      </AuthCard>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (!values.password) {
    errors.password = 'Please enter password'
  }
  return errors
}

export default reduxForm({
  form: 'resetPassword',
  validate
})(ResetPasswordForm)



// WEBPACK FOOTER //
// ./src/views/ResetPassword/components/ResetPasswordForm/index.js